<div class="ts-badge ts-badge--{{ type }}" [class.floating]="floating" [class.no-overlap]="noOverlap">
  @if (showSpinner) {
    <mat-spinner [diameter]="12" class="inline-spinner"></mat-spinner>
  }
  {{ value }}
</div>
